import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    kpiMasterList : []
};

export default function (state = initialState, action) {
    //console.log(action);
    switch (action.type) {
        case actionTypes.STORE_KPI_MASTER_LIST: 
        return {...state,kpiMasterList : action.val};
        default:
          break;
    }
    return state;
}